export default __webpack_public_path__ + "static/media/image-light.c54cee17.svg";